//#region src/order_search_token.ts
let OrderSearchToken = /* @__PURE__ */ function(OrderSearchToken) {
	OrderSearchToken["IsUnclosedOrUnfinished"] = ":is-unclosed-or-unfinished";
	OrderSearchToken["IsAbandoned"] = ":is-abandoned";
	OrderSearchToken["IsUnsent"] = ":is-unsent";
	OrderSearchToken["IsFuture"] = ":is-future";
	OrderSearchToken["HasRefunds"] = ":has-refunds";
	OrderSearchToken["HasFailedToSendToPos"] = ":has-failed-to-send-to-pos";
	OrderSearchToken["IsHeldForFulfillment"] = ":held-for-fulfillment";
	OrderSearchToken["HasStoredValueOrLoyaltyTransaction"] = ":has-stored-value-or-loyalty-transaction";
	OrderSearchToken["HasDiscount"] = ":has-discount";
	OrderSearchToken["HasLoyaltyRedemption"] = ":has-loyalty-redemption";
	OrderSearchToken["IsToGo"] = ":to-go";
	OrderSearchToken["IsDineIn"] = ":dine-in";
	OrderSearchToken["IsCurbside"] = ":curbside";
	OrderSearchToken["IsOutpost"] = ":outpost";
	OrderSearchToken["IsDelivery"] = ":delivery";
	return OrderSearchToken;
}({});
//#endregion
export { OrderSearchToken };

//# sourceMappingURL=order_search_token.js.map